import styled from 'styled-components';
import { ActionCell } from '#/components/rfq-common/ActionButtons';
import { RfqActionRow } from '#/components/UnifiedRfqs/rfqs/action/common';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { useUmTakerProfileFeatureFlag } from '@paradigm/features/src/feature-flags/context';

export default function RfqActionHeader() {
  const isTakerProfileEnabled = useUmTakerProfileFeatureFlag();
  return (
    <RfqActionRowHeader>
      <ProfileActionCell>
        {isTakerProfileEnabled ? 'Profile' : null}
      </ProfileActionCell>
      <ActionCell>Qty</ActionCell>
      <ActionCell />
      <ActionCell>Bid</ActionCell>
      <ActionCell>Mark</ActionCell>
      <ActionCell>Ask</ActionCell>
      <ActionCell />
      <ActionCell>Qty</ActionCell>
    </RfqActionRowHeader>
  );
}

const ProfileActionCell = styled(ActionCell)`
  justify-content: start;
  padding-left: 20px;
`;

const RfqActionRowHeader = styled(RfqActionRow)`
  justify-content: start;
  grid-template-areas: 'profile bqty bkill bid mark ask akill aqty';
  grid-template-columns: 140px 74px 10px 90px 90px 90px 10px 74px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 0fr 7fr 1fr 8fr 7fr 8fr 1fr 7fr;
  }
`;
